<template>
  <v-container fluid fill-height justify-center align-start align-lg-center id="scrolling-techniques-7" class="overflow-y-auto pt-0 pl-0 pr-4 pb-12" key="settings">
    
    <v-fade-transition
      hide-on-leave
    >
      <v-timeline dense class="not-timeline" v-if="notifications.length > 0">
        <v-slide-x-reverse-transition
          group
          hide-on-leave
        >
          <v-timeline-item
            key="0"
            fill-dot
            hide-dot
            large
          >
            <v-btn slot="icon" large icon class="white--text">
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <span class="headline font-weight-bold">{{ $t('historia-alarmow') }}</span>
          </v-timeline-item>

          <v-timeline-item
            v-for="item in notifications"
            :key="item.id"
            :color="colors[item.type]"
            fill-dot
          >
            <v-btn slot="icon" icon class="white--text" @click="approveItem(item.id)">
              <v-icon>{{ icons[item.type] }}</v-icon>
            </v-btn>

            <v-alert
              v-if="notApprovedIds.indexOf(item.id) >= 0"
              class="body-2 br-3 mb-0"
            >
              <v-row justify="space-between" align="center">
                <v-col cols="4" class="py-0"><span v-html="dateShort(item.date)"></span></v-col>
                <v-col cols="8" class="py-0">
                  {{ $t('alarm' + item.message) }}
                </v-col>
              </v-row>
            </v-alert>
            <v-row 
              v-else
              align="center" class="body-2"
            >
              <v-col cols="4" class="pl-5 overlinee"><span v-html="dateShort(item.date)"></span></v-col>
              <v-col cols="8" class="pr-4">
                {{ $t('alarm' + item.message) }}
              </v-col>
            </v-row>
          </v-timeline-item>

          <v-timeline-item
            key="new"
            fill-dot
            class="mb-8"
            :hide-dot="!showAppend"
          >
            <v-btn slot="icon" icon class="white--text" @click="appendAlerts">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
            <v-row>
              <v-col class="py-10">&nbsp;</v-col>
            </v-row>
          </v-timeline-item>
        </v-slide-x-reverse-transition>
      </v-timeline>
      <v-row class="max-w" v-if="noAlarms">
        <v-col>
          <div class="headline font-weight-bold relative px-4 mt-6 text--primary">
            {{ $t('brak-alarmow') }}
          </div>
        </v-col>
      </v-row>
    </v-fade-transition>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
      noAlarms: false,
      showAppend: true
    }),
  computed: {
    ...mapGetters([
      'controllers',
      'controllerById'
    ]),
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    notifications() {
      return this.$store.getters['alerts/list']
    },
    notificationsCount() {
      return this.notifications.length;
    },
    icons() {
      return this.$store.state['alerts'].icons
    },
    colors() {
      return (this.$vuetify.theme.dark) 
      ? ['#EF5350','#FB8C00','#FB8C00','#42A5F5'] 
      : ['red','orange','orange','blue'];
    },
    notApproved() {
      return this.$store.getters['notifications/notApproved']
    },
    notApprovedIds() {
      return this.$store.getters['notifications/notApprovedIds']
    }
  },
  created () {
    if (!(this.$store && this.$store.state && this.$store.state[this.moduleName])) {
      this.$router.push({ path: '/dashboard/' + this.controllerId });
    } else {
      this.loadAlerts(false)
      .then(res => {
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
        } else if (this.notifications.length == 0) {
          this.noAlarms = true;
        }
      });
    }
  },
  methods: {
    loadAlerts(forced) {
      return this.$store.dispatch(`alerts/load`, { controllerId: this.controllerId, startIndex: 1, forced: forced })
    },
    appendAlerts() {
      this.$store.dispatch(`alerts/load`, { controllerId: this.controllerId, startIndex: this.notificationsCount + 1, forced: true })
      .then(res => {
        if (res.length == 0) {
          this.showAppend = false;
        }
      });
    },
    dateShort(value) {
      if (!value) return ''

      var nonthShort = {'01':'sty','02':'lut','03':'mar','04':'kwi','05':'maj','06':'cze','07':'lip','08':'sie','09':'wrz','10':'paź','11':'lis','12':'gru'},
      dat = value.split(' '),
      h = dat[1].slice(0, 5),
      d = dat[0].slice(8, 10),
      m = dat[0].slice(5, 7)
      
      return h + '<br />' + d + ' ' + nonthShort[m];
    },
    approveItem(id) {
      this.$store.dispatch(`notifications/approveNotifications`, [{id: id}]);
    }
  }
}
</script>

<style>

</style>

          